'use strict';

angular.module('portal.applications', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // portal routings
            // applications tab
            .state('portal.menus.applicationsStart', {
                url: '/applications/start',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.applications', {
                url: '/applications/continue',
                templateUrl: paths.app + 'applications/components/applications/applications.html',
                controller: 'PortalApplications',
                params: {
                    review: false,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.applicationsContinueList', {
                url: '/applications/continue/list',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.applicationsList', {
                url: '/applications/mylist',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.applicationsServiceList', {
                url: '/applications/servicelist?serviceId',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    loginRequired: true,
                    serviceId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.application', {
                url: '/application/:id/response/:responseID/:fireStartTrigger',
                templateUrl: paths.app + 'applications/components/application-response/application-response.html',
                controller: 'PortalApplicationResponse',
                params: {
                    id: null,
                    application: null,
                    responseID: null,
                    response: null,
                    fireStartTrigger: null,
                    review: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$q', '$state', '$stateParams', '$rootScope', 'LicenseRequests', 'PortalPermissions', function ($q, $state, $stateParams, $rootScope, LicenseRequests, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        PortalPermissions.view('portal.menus.applications').then(function (access) {
                            if (!access) {
                                //Old continue page or new continue page must be turned on
                                PortalPermissions.view('portal.menus.applicationsContinueList').then(function (access) {
                                    if (!access) {
                                        $state.go('portal.menus.denied');
                                    }
                                });
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.review', {
                url: '/applications/review',
                templateUrl: paths.app + 'applications/components/applications/applications.html',
                controller: 'PortalApplications',
                params: {
                    review: true,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;

                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.checkout', {
                url: '/applications/checkout',
                templateUrl: paths.app + 'applications/components/application-checkout/application-checkout.html',
                controller: 'PortalApplicationsCheckout',
                params: {
                    redirectImmediately: false,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        //Need permission to old checkout page or new checkout page
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                PortalPermissions.view('portal.menus.checkoutlist').then(function (checkoutAccess) {
                                    if (!checkoutAccess) {
                                        $state.go('portal.menus.denied');
                                    }
                                });
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.checkoutlist', {
                url: '/applications/checkout/list',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.payment', {
                url: '/applications/checkout/payment',
                templateUrl: paths.app + 'applications/components/application-checkout-payment/application-checkout-payment.html',
                controller: 'PortalApplicationsCheckoutPayment',
                params: {
                    review: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.payment2', {
                url: '/applications/payments/checkout',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    review: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        PortalPermissions.view('portal.menus.payment').then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.paymentResponse', {
                url: '/applications/payments/response/:actionString',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    actionString: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$rootScope', function ($rootScope) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('portal.menus.paymentResponseNoAction', {
                url: '/applications/payments/response',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    actionString: null,
                    loginRequired: true
                },
                resolve: {
                    permission: ['$rootScope', function ($rootScope) {
                        $rootScope.$state.current = this.self;
                    }]
                }
            })
            .state('portal.menus.applicationsHistory', {
                url: '/applications/history',
                templateUrl: paths.app + 'react/components/application/application.html',
                controller: 'PortalApplicationsCheckout2',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
    }])
;